import { type CanvasEventTarget } from '@canvas/input-types';

import { element, getCanvasTargetFromDOM } from './util.ts';

/**
 * List of targets that are banned from being considered as editor targets.
 */
const bannedEditorTargets: CanvasEventTarget[] = [
  'comment-thread',
  'comment-thread-container',
  'export-menu',
  'ai-first-creation-prompt',
  'ai-agent-dialog-editor',
  'blank-object-side-modal',
  'blank-object-inline-modal',
  'section-action-drawer',
];

const isBannedEditorTarget = (target: EventTarget | null) => {
  if (!target) {
    return false;
  }

  const canvasTargetFromDOM = getCanvasTargetFromDOM(target);
  return canvasTargetFromDOM && bannedEditorTargets.includes(canvasTargetFromDOM);
};

export const isEditorContent = (
  target: EventTarget | null,
  checkBannedTargets = true,
): boolean => {
  if (checkBannedTargets && isBannedEditorTarget(target)) {
    return false;
  }

  return !!element((target as HTMLElement)?.parentElement)?.closest('.ProseMirror');
};

export const isEditorContainer = (
  target: EventTarget | null,
  checkBannedTargets = true,
): boolean => {
  if (checkBannedTargets && isBannedEditorTarget(target)) {
    return false;
  }

  return !!element(target)?.classList.contains('ProseMirror');
};
